// extracted by mini-css-extract-plugin
module.exports = {"shareBtn":"styles_shareBtn__KY9rU"};